import { render, staticRenderFns } from "./TermosCondicoes.vue?vue&type=template&id=7c1afaf8&scoped=true&"
import script from "./TermosCondicoes.vue?vue&type=script&lang=js&"
export * from "./TermosCondicoes.vue?vue&type=script&lang=js&"
import style0 from "./TermosCondicoes.vue?vue&type=style&index=0&id=7c1afaf8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c1afaf8",
  null
  
)

export default component.exports